import { SetReducerState } from '../types/types';
import { ActionTypes, SET_USER_INFO, SET_COMPANY, CLEAR_USER_INFO, CLEAR_COMPANY } from './action';

const initialState: SetReducerState = {
  userInfo: null,
  company: null,
};

const setReducer = (state = initialState, action: ActionTypes): SetReducerState => {
  switch (action.type) {
    case SET_USER_INFO:
      return {
        ...state,
        userInfo: action.payload,
      };
    case SET_COMPANY:
      return {
        ...state,
        company: action.payload,
      };
    case CLEAR_USER_INFO:
      return {
        ...state,
        userInfo: null,
      };
    case CLEAR_COMPANY:
      return {
        ...state,
        company: null,
      };
    default:
      return state;
  }
};

export default setReducer;
